import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';
import Video from '@/models/Video';

Vue.use(Vuex);

const video = ({
    state: {
        videoSettings: {
            fluid: true,
            techOrder: [],
            showControls: 1,
            controls: true,
            controlBar: {
                playToggle: true,
                captionsButton: false,
                chaptersButton: false,
                subtitlesButton: false,
                remainingTimeDisplay: true,
                progressControl: {
                    seekBar: true
                },
                fullscreenToggle: true,
                playbackRateMenuButton: false,
                pictureInPictureToggle: true,
                volumePanel: true,
                muteToggle: false
            },
            autoplay: true,
            muted: false,
            theme: '',
            poster: '',
            sources: [{
                src: '',
                type: 'video/mp4'
            }],
            watermark: {
                source: '',
                position: 'top-left'
            },
            loop: false,
            playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2],
            userActions: {
                doubleClick: true,
            },
        },
        videoOverlayText: '',
        videoDimension: {
            type: 1,
            height: 720,
            width: 1280
        },
        videoPlayerComponentKey: 0,
        custom_source_type_id: 0,
    },
    getters: {
        getVideoSettings: (state) => {
            return state.videoSettings;
        },
        getVideoOverlayText: (state) => {
            return state.videoOverlayText;
        },
        getVideoDimesion: (state) => {
            return state.videoDimension;
        },
        getVideoComponentKey: (state) => {
            return state.videoPlayerComponentKey;
        },
        getPlayerPrimaryColor: (state) => {
            return state.videoSettings.color.primary;
        },
        getPlayerSecodaryColor: (state) => {
            return state.videoSettings.color.secondary;
        },
        getWatermarkSource: (state) => {
            return typeof state.videoSettings.watermark !== 'undefined'
                ? state.videoSettings.watermark.source
                : '';
        },
        getWatermarkPosition: (state) => {
            return typeof state.videoSettings.watermark !== 'undefined'
                ? state.videoSettings.watermark.position
                : '';
        },
        getVideoCustomSourceId: (state) => {
            return state.custom_source_type_id;
        }

    },
    mutations: {
        setVideoSrc: (state, source) => {
            state.videoSettings.sources[0].src = source;
        },
        setVideoType: (state, type) => {
            state.videoSettings.sources[0].type = type;
        },
        setVideoTechorder: (state, techOrder) => {
            state.videoSettings.techOrder[0] = techOrder;
        },
        setVideoPoster: (state, payload) => {
            state.videoSettings.poster = payload;
        },
        setplayerPrimaryColor: (state, payload) => {
            state.videoSettings.color.primary = payload;
        },
        setplayerSecondaryColor: (state, payload) => {
            state.videoSettings.color.secondary = payload;
        },
        setVideoWatermarkSource: (state, payload) => {
            state.videoSettings.watermark.source = payload;
        },
        setVideoWatermarkPosition: (state, payload) => {
            state.videoSettings.watermark.position = payload;
        },
        setVideoAutoload: (state, autoLoad) => {
            state.videoSettings.autoplay = autoLoad;
        },
        setVideoMute: (state, mute) => {
            state.videoSettings.muted = mute;
        },
        setVideoControls: (state, control) => {
            state.videoSettings.showControls = control == true || control == 1 ? 1 : 0;
        },
        setVideoTheme: (state, theme) => {
            state.videoSettings.theme = theme == null || theme == " " ? 'vjs-theme-default' : theme;
        },
        setVideoOverlayText: (state, overlayText) => {
            state.videoOverlayText = overlayText;
        },
        setVideoDimension: (state, dimension) => {
            state.videoDimension = dimension;
        },
        setVideoEndActions: (state, endAction) => {
            state.videoSettings.loop = endAction === '2' || state.videoSettings.autoplay;
        },
        setVideoComponentKey: (state) => {
            state.videoPlayerComponentKey++;
            console.log("VideoPlayecomponentKey Count", state.videoPlayerComponentKey);
        },
        setVideoCustomSourceId: (state) => {
            state.custom_source_type_id += 1;
        }
    },
    actions: {
        videoSrc({ commit }, videoSrc) {
            commit('setVideoSrc', videoSrc);
        },
        videoType({ commit }, videoType) {
            commit('setVideoType', videoType);
        },
        videoTechOrder({ commit }, videoTech) {
            commit('setVideoTechorder', videoTech);
        },
        videoPoster({ commit }, payload) {
            commit('setVideoPoster', payload);
        },
        playerPrimaryColor({ commit }, payload) {
            commit('setPlayerPrimaryColor', payload);
        },
        playerSecondaryColor({ commit }, payload) {
            commit('setPlayerSecondaryColor', payload);
        },
        videoWatermarkSource({ commit }, payload) {
            commit('setVideoWatermarkSource', payload);
        },
        videoWatermarkPosition({ commit }, payload) {
            commit('setVideoWatermarkPosition', payload);
        },
        videoAutoLoad({ commit }, autoLoad) {
            commit('setVideoAutoload', autoLoad);
        },
        videoMute({ commit }, mute) {
            commit('setVideoMute', mute);
        },
        videoVideoControl({ commit }, control) {
            commit('setVideoControls', control);
        },
        videoTheme({ commit }, theme) {
            commit('setVideoTheme', theme);
        },
        videoOverlayText({ commit }, overlayText) {
            commit('setVideoOverlayText', overlayText);
        },
        videoDimension({ commit }, dimension) {
            commit('setVideoDimension', dimension);
        },
        videoEndAction({ commit }, endAction) {
            commit('setVideoEndActions', endAction);
        },
        videoComponentKey({ commit }) {
            commit('setVideoComponentKey');
        },
        videoCustomSourceId({ commit }) {
            commit('setVideoCustomSourceId');
        }
    },
});

export default video;